import React, { useMemo } from "react";

import { Dropdown } from "semantic-ui-react";

import { QUESTIONS } from "containers/Form/SimplifiedBuilder/Components/Question/Footer/utils";


export const DefaultQuestionTypeSelector = ({ config, onChangeConfig }) => {
	const typeValue = useMemo(() => config.type === "one"
		? "number"
		: config.type,
	[ config.type ],
	);


	return (
		<Dropdown
			search
			selection
			options={QUESTIONS}
			value={typeValue}
			onChange={(e, { value }) => onChangeConfig({ type: value })}
		/>
	);
};
